function replacePlaceholder(url, data) {
    return url.replace(/{(\w+)}/g, function(match, p1) {
        return data[p1] && data[p1].value;
    });
}

export const parseUrlConfig = (urlConfig, camundaVariables) => {

    let url = (urlConfig && urlConfig.type === "api" && urlConfig.value) || "";

    if(urlConfig && urlConfig.type === "api" && urlConfig.value 
            && camundaVariables && camundaVariables.camundaValues){

        url = replacePlaceholder(urlConfig.value, camundaVariables.camundaValues);
    }

    return url;
}